<nb-card class="card-scroll">
	<nb-card-header class="card-header-title">
		<div class="card-header-title">
			<h4>{{ 'MENU.SETTINGS' | translate }}</h4>
		</div>
	</nb-card-header>
	<nb-card-body>
		<router-outlet></router-outlet>
	</nb-card-body>
</nb-card>
